export const GET_CLIENTS = "GET_CLIENTS";

export const GetClients = () => {
    return { type: GET_CLIENTS };
};
